<template>
  <div class="container mt-4">
    <!-- TOAST -->
    <div
      v-if="mostrarToast"
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 2000"
    >
      <div class="toast show text-white" :class="toastColor">
        <div class="d-flex">
          <div class="toast-body">
            <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
          </div>
          <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            @click="cerrarToast"
          ></button>
        </div>
      </div>
    </div>

    <div class="card p-4 shadow-sm">
      <template v-if="reserva">
        <h4 class="text-center mb-4">
          Detalle de Reserva #R00{{ reserva.IdReserva }}
        </h4>

        <!-- ESTADO -->
        <div class="text-center mb-3">
          <span v-if="reserva.EstadoReserva === 3" class="badge bg-danger fs-6"
            >Cancelada</span
          >
          <span
            v-else-if="reserva.EstadoReserva === 1"
            class="badge bg-success fs-6"
            >Check-In realizado</span
          >
          <span
            v-else-if="reserva.ConfirmadaPorHuesped"
            class="badge bg-primary fs-6"
            >✓ Confirmada por huésped</span
          >
          <span v-else class="badge bg-warning text-dark fs-6"
            >Pendiente de confirmación</span
          >
        </div>

        <!-- ===================== -->
        <!--   HUESPED & FECHAS    -->
        <!-- ===================== -->
        <div class="row mb-4">
          <!-- HUESPED -->
          <div class="col-md-6">
            <h5>🧍 Huésped</h5>
            <ul class="list-group">
              <li class="list-group-item">
                <strong>Nombre:</strong> {{ reserva.huesped.Nombre }}
                {{ reserva.huesped.Apellido }}
              </li>
              <li class="list-group-item">
                <strong>Teléfono:</strong>
                {{ limpiarTelefono(reserva.huesped.Telefono) }}
              </li>
            </ul>
          </div>

          <!-- FECHAS -->
          <div class="col-md-6">
            <h5>📅 Fechas</h5>
            <ul class="list-group">
              <li class="list-group-item">
                <strong>Fecha Reserva:</strong>
                {{ fHora(reserva.FechaReserva) }}
              </li>
              <li class="list-group-item">
                <strong>Fecha Llegada:</strong>
                {{ fFecha(reserva.FechaLlegada) }}
              </li>
              <li class="list-group-item">
                <strong>Fecha Salida:</strong> {{ fFecha(reserva.FechaSalida) }}
              </li>
            </ul>
          </div>
        </div>

        <!-- HABITACIONES -->
        <h5>🛏 Habitaciones</h5>
        <div class="table-responsive">
          <table class="table table-bordered table-sm text-center mb-4">
            <thead>
              <tr>
                <th>Número</th>
                <th>Tipo</th>
                <th>Personas</th>
                <th>Niños</th>
                <th>Precio</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="h in reserva.habitaciones_reservadas"
                :key="h.IdReservaHabitacion"
              >
                <td>{{ h.habitacion.Numero }}</td>
                <td>{{ h.habitacion.tipo.Nombre }}</td>
                <td>{{ h.CantidadPersonasAlojadas }}</td>
                <td>{{ h.CantidadNinios }}</td>
                <td>Q{{ Number(h.Precio).toFixed(2) }}</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <!-- Como ahora solo hay 5 columnas → colspan debe ser 4 -->
                <td colspan="4" class="text-end"><strong>Total:</strong></td>
                <td>
                  <strong>Q{{ totalHabitaciones }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- ====================================== -->
        <!--   BOTÓN CANCELAR (solo si estado != 3)  -->
        <!-- ====================================== -->
        <!-- BOTÓN CONFIRMAR O MENSAJE -->
        <div class="text-center">
          <!-- Si NO está cancelada NI en check-in -->
          <div
            v-if="reserva.EstadoReserva !== 3 && reserva.EstadoReserva !== 1"
          >
            <!-- Confirmar (solo si aún no fue confirmada) -->
            <button
              v-if="!reserva.ConfirmadaPorHuesped"
              class="btn btn-primary btn-lg"
              data-bs-toggle="modal"
              data-bs-target="#modalConfirmar"
            >
              ✓ Confirmar reserva
            </button>
            <p v-else class="text-primary fw-bold mt-3">
              ✓ Ya confirmaste tu asistencia
            </p>
          </div>

          <!-- Si YA está cancelada, mostrar mensaje rojo -->
          <div v-else-if="reserva.EstadoReserva === 3">
            <p class="text-danger fw-bold mt-3">La reserva ya fue cancelada</p>
          </div>

          <!-- Si está en check-in, mostrar mensaje verde -->
          <div v-else-if="reserva.EstadoReserva === 1">
            <p class="text-success fw-bold mt-3">Check-In realizado</p>
          </div>
        </div>

        <!-- ================================ -->
        <!--     MODAL CONFIRMAR RESERVA      -->
        <!-- ================================ -->
        <div class="modal fade" id="modalConfirmar" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white">
                <h5 class="modal-title">Confirmar reserva</h5>
                <button
                  type="button"
                  class="btn-close btn-close-white"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div class="modal-body">
                ¿Confirmas tu asistencia para esta reserva?
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" data-bs-dismiss="modal">
                  No
                </button>
                <button class="btn btn-primary" @click="confirmar">
                  Sí, confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="text-center py-5 text-muted">
          <div class="spinner-border text-primary"></div>
          <p>Cargando información...</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";

export default {
  name: "CancelarReservaPublico",
  data() {
    return {
      reserva: null,
      codigo: null,
      alerta: { mensaje: "", tipo: "success" },
      mostrarToast: false,
    };
  },

  async mounted() {
    this.codigo = this.$route.params.codigo;

    try {
      const res = await axios.get(
        `${API_URL}/ver-detalle-publico/${this.codigo}`,
      );
      this.reserva = res.data.reserva;
    } catch (e) {
      console.error("Error al cargar detalles:", e);
    }
  },

  computed: {
    totalHabitaciones() {
      if (!this.reserva) return "0.00";
      return this.reserva.habitaciones_reservadas
        .reduce((t, h) => t + Number(h.Precio), 0)
        .toFixed(2);
    },
    toastColor() {
      return (
        {
          success: "bg-success",
          danger: "bg-danger",
          warning: "bg-warning text-dark",
          info: "bg-info text-dark",
        }[this.alerta.tipo] || "bg-primary"
      );
    },
    iconoToast() {
      return (
        {
          success: "bi bi-check-circle-fill",
          danger: "bi bi-x-circle-fill",
          warning: "bi bi-exclamation-triangle-fill",
          info: "bi bi-info-circle-fill",
        }[this.alerta.tipo] || "bi bi-info-circle-fill"
      );
    },
  },

  methods: {
    async confirmar() {
      let modal = document.getElementById("modalConfirmar");
      if (bootstrap && modal) {
        const m =
          bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
        m.hide();
      }
      try {
        const res = await axios.put(
          `${API_URL}/reservas/${this.codigo}/confirmar-publico`,
        );
        this.mostrarAlerta(res.data.message, "success");
        const resDetalle = await axios.get(
          `${API_URL}/ver-detalle-publico/${this.codigo}`,
        );
        this.reserva = resDetalle.data.reserva;
      } catch (error) {
        this.mostrarAlerta(
          error.response?.data?.message || "No se pudo confirmar la reserva.",
          "danger",
        );
      }
      setTimeout(() => {
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.parentNode.removeChild(el));
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }, 300);
    },

    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(() => {
        this.mostrarToast = false;
      }, 3000);
    },

    cerrarToast() {
      this.mostrarToast = false;
    },

    fFecha(f) {
      if (!f) return "";
      const fecha = f.split(" ")[0].split("T")[0];
      const [y, m, d] = fecha.split("-");
      return `${d}/${m}/${y}`;
    },

    fHora(f) {
      if (!f) return "";
      const [fecha, hora] = f.split(" ");
      const [y, m, d] = fecha.split("-");
      return `${d}/${m}/${y} ${hora?.slice(0, 5) || ""}`;
    },

    limpiarTelefono(tel) {
      if (!tel) return "";
      return String(tel).replace(/^502/, "");
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
/* Asegura que el toast esté por encima del modal */
.toast-container {
  z-index: 2000 !important;
}
</style>
